import React, { ReactNode } from 'react';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

interface BotsActivityHeroProps {
  updatedAt: Date | null;
  headlineText: string;
  tiles?: ReactNode;
}

export const BotsActivityHero: React.FC<BotsActivityHeroProps> = ({
  updatedAt,
  headlineText,
  tiles,
}) => {
  const { t } = useTranslation();

  return (
    <header className="bots-activity__hero">
      <div className="bots-activity__hero-text">
        {updatedAt && (
          <div className="bots-activity__updated">
            {t('botsActivity.updatedAt', { date: format(updatedAt, 'd MMM yyyy') })}
          </div>
        )}
        <h2 className="bots-activity__hero-title">{headlineText}</h2>
      </div>
      {tiles}
    </header>
  );
};

export default BotsActivityHero;
